import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import moment from "moment";
import { Grid, Box } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from "react-i18next";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Controls from "./Controls";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import { getWareHouseMetricsReportData } from "../../utils/report";
import DateFnsUtils from "@date-io/date-fns";

import LoaderViewNew from "../Timesheet/LoaderViewNew";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  TextField,
  Button,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
// Router
import { useHistory } from "react-router-dom";

import { Link, useLocation } from "react-router-dom";
import { getWorkersByMgr } from "services";
import WareHouseTimeLineView from "./Cards/WareHouseTimeLineView";
import { WARE_HOUSE_TIMELINE_VIEW } from "navigation/CONSTANTS";
import {
  MY_TEAM,
  MANAGE_FOR_BY_COUNTRY,
  WORKER_ID,
  DELETED,
  IN,
} from "config/CONSTANTS";
import { getStartOfWeek, getEndOfWeek, properCase, isEmptyObject } from "utils";
import {
  getDistrictBuildingMapForIMWarehouse,
  getParentManager,
  getWeekNumber,
} from "services";
import { getWorkerName } from "../Timesheet/utils";
import { getFullName } from "utils";
import { timeConfig, dateConfig } from "pages/Punch/config";
import { getWorkerPunchRecords } from "services";
import {analytics} from 'services/firebase';
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export const WareHouseTimeLineViewContainer = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const locationProps = location.state;
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  const isManager = isAuthenticated && user.isApprover && user.isActiveWorker;
  const loggedInUser = useSelector((state) => state.user);
  const loggedInUserDet = loggedInUser.auth.user;
  const loggedInSupervisor = loggedInUser.auth.user.workerId;
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [employeeTimeLineViewLoading, setEmployeeTimeLineViewLoading] =
    useState(false);
  const [isViewDisabled, SetIsViewDisabled] = React.useState(true);
  const [timeLineViewData, setTimeLineViewData] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedWorker, setSelectWorker] = useState({});
  const [empTimeLineData, setEmpTimeLineData] = useState([]);
  const isSandbox = process.env.REACT_APP_ENV !== "prod";
  let [inTimes, setinTimes] = useState();
  let [outTimes, setoutTimes] = useState();
  let workerName = "";
  if (selectedWorker && Object.keys(selectedWorker).length > 0) {
    console.log("selectedWorker",selectedWorker);
    workerName = getWorkerName(selectedWorker);
  }

  // useEffect(()=>{
  //   console.log('isViewDisabled:', isViewDisabled);
  //   if(isViewDisabled){
  //     console.log('isViewDisabled: failure', isViewDisabled);
  //     setTimeLineViewData(false);
  //   }
  // },[isViewDisabled])

  useEffect(()=>{
    if(user.workerId){
      analytics.logEvent('imtime_timeline_page_visited',{
        userId:user?user.workerId:"",
        userName:user.firstName+" "+user.lastName,
        userCountry:user.country?user.country:""
      })
    }
  },[user])

  const loadTimeLineView = async () => {
    const workerId = selectedWorker.workerId;
    console.log("selected workerId:", workerId);
    analytics.logEvent('imtime_timeline_data_viewed',{
      userId:user?user.workerId:"",
      userName:user.firstName+" "+user.lastName,
      userCountry:user.country?user.country:""
    })
    setEmployeeTimeLineViewLoading(true);
    SetIsViewDisabled(true);
    const startDate = moment(selectedDate).format(dateConfig.format6);
    const endDate = moment(selectedDate)
      .endOf("day")
      .format(dateConfig.format4);
    await getWorkerPunchRecords(workerId, startDate, endDate).then((result) => {
      let inTime = result[0];
      let lenOut = result.length;
      let outTime = result[lenOut - 1];
      if (inTime === undefined) {
        setinTimes("");
        setoutTimes("");
      } else {
        setinTimes(inTime.inLocalTS);
        setoutTimes(outTime.outLocalTS);
      }
    });
    console.log("inTime", inTimes);
    console.log("outTime", outTimes);
    await getWareHouseMetricsReportData(
      selectedWorker.country,
      workerId,
      selectedDate
    )
      .then((data) => {
        if (data && data.length > 0) {
          console.log(
            "data:",
            data.map((record) => record.id)
          );
          setTimeLineViewData(true);
          data.forEach((record) => {
            record.activityTimeFormat =
              moment(record.activityStartDateTime).format(timeConfig.format3) +
              "-" +
              moment(record.activityEndDateTime).format(timeConfig.format3);
          });
          setEmpTimeLineData(data);
        } else {
          setTimeLineViewData(false);
        }
        setEmployeeTimeLineViewLoading(false);
      })
      .catch((e) => {
        console.log("error while loading timeLine details:", e);
        setEmployeeTimeLineViewLoading(false);
        setTimeLineViewData(false);
      });
  };
  return (
    <>
      <LoaderViewNew loading={loading}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Box
            mt={2}
            display="flex"
            flexDirection="column"
            style={{
              width: "100%",
              backgroundColor: "#fff",
              overflow: "auto",
              // height:'100%'
              height: `calc(100vh - (113px - ${isSandbox ? 0 : 65}px) - 32px)`,
            }}
          >
            <Controls
              setLoading={setLoading}
              locationProps={locationProps}
              workerName={workerName}
              loggedInSupervisor={loggedInSupervisor}
              setSelectWorker={setSelectWorker}
              loggedInUser={loggedInUserDet}
              loadTimeLineView={loadTimeLineView}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              SetIsViewDisabled={SetIsViewDisabled}
              isViewDisabled={isViewDisabled}
              setTimeLineViewData={setTimeLineViewData}
              setinTimes={setinTimes}
              setoutTimes={setoutTimes}
            />
            <Box
              display="flex"
              flexDirection="row"
              paddingLeft={2}
              paddingRight={2}
              paddingBottom={2}
            >
              {timeLineViewData ? (
                <WareHouseTimeLineView
                  title={t("other.lblTimelLineView")}
                  empTimeLineData={empTimeLineData}
                  employeeTimeLineViewLoading={employeeTimeLineViewLoading}
                  timeLineViewData={timeLineViewData}
                  selectedDate={selectedDate}
                  inTimes={inTimes}
                  outTimes={outTimes}
                  workerName={workerName}
                />
              ) : (
                <Alert severity="info">{t("other.errNoReportData3")}</Alert>
              )}
            </Box>
          </Box>
        </MuiPickersUtilsProvider>
      </LoaderViewNew>
    </>
  );
};

export default WareHouseTimeLineViewContainer;
